module.exports = __webpack_public_path__ + "static/img/6359_phase_function_Paper_Points.7d3fb01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6359_phase_function_Paper_Points.png
// module id = kjma
// module chunks = 0